import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=df9afa20&scoped=true"
import script from "./BasePanel.vue?vue&type=script&lang=js"
export * from "./BasePanel.vue?vue&type=script&lang=js"
import style0 from "./BasePanel.vue?vue&type=style&index=0&id=df9afa20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9afa20",
  null
  
)

export default component.exports